module.exports = __webpack_public_path__ + "img/invoice-pt.f118ce39.png";